(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bread-feature"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
    };
    new Splide('.feature-splide-points', options).mount();
    new Splide('.feature-splide-chart', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-mv"]) return;
  try {
    
  $(function () {
    $('.concept-slideshow-sp').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      dots: false,
      fade: true,
      cssEase: 'linear',
      speed: 300,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });

    $('.concept-slideshow-pc').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      dots: false,
      fade: true,
      cssEase: 'linear',
      speed: 300,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-nutrients"]) return;
  try {
    
  MicroModal.init({
    disableScroll: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-campaign"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
    };
    new Splide('.campaign-splide-points', options).mount();
    new Splide('.campaign-splide-chart', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-feature"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
    };
    new Splide('.feature-splide-points', options).mount();
    new Splide('.feature-splide-chart', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-anytime"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const options = {
    pagination: false,
    type: "loop", 
    padding: "30%",
    focus: "center", 
    breakpoints: {
		680: {
			padding: "0",
    	},
    }
  };
  const splide = new Splide( '.anytime-splide', options ).mount();

  document.querySelector('.js-prev-any').addEventListener('click', e => {
    splide.go('-1');
  });

   document.querySelector('.js-next-any').addEventListener('click', e => {
    splide.go('+1');
  });

  MicroModal.init({
    disableScroll: true,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-feature"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 16,
      gap: '40px',
      breakpoints: {
        680: {
          gap: '40px',
        },
      },
    };
    new Splide('.feature-splide', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-guilt"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const options = {
    pagination: false,
    gap: 16
  };
  new Splide( '.feature-splide', options ).mount();
  new Splide( '.amino-splide', options ).mount();

  MicroModal.init({
    disableScroll: true,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-interview"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 60,
      width: "100vw",
      mediaQuery: "min",
      breakpoints: {
        680: {
          destroy: true,
        },
      },
    };
    new Splide( '.exercise-splide', options ).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-questionnaire-rizin"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      arrows: false,
      type: 'loop',
      focus: 'center',
      gap: '68px',
      breakpoints: {
        680: {
          gap: '24px',
        },
      },
    };
    const splide = new Splide('.questionnaire-splide', options).mount();

    const navItems = ['.js-q1', '.js-q2', '.js-q3'];
    let currentNav = 0;

    const setActiveNav = (index) => {
      navItems.forEach((selector, i) => {
        document.querySelector(selector).classList.toggle('is-active', i === index);
      });
      currentNav = index;
    };

    document.querySelector('.js-prev').addEventListener('click', () => {
      splide.go('-1');
      setActiveNav((currentNav + navItems.length - 1) % navItems.length);
    });

    document.querySelector('.js-next').addEventListener('click', () => {
      splide.go('+1');
      setActiveNav((currentNav + 1) % navItems.length);
    });

    navItems.forEach((selector, index) => {
      document.querySelector(selector).addEventListener('click', () => {
        splide.go(index);
        setActiveNav(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-questionnaire"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      arrows: false,
      type: "loop",
      focus: "center",
      gap: "68px",
      breakpoints: {
  		680: {
  			gap: "24px",
      	},
      }
    };
    const splide = new Splide( '.questionnaire-splide', options ).mount();

    const navReset = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
    }

    let currentNav = 0;

    const changeNav = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
      if(currentNav === 0) {
        document.querySelector('.js-q1').classList.add('is-active');
      }else if (currentNav === 1) {
        document.querySelector('.js-q2').classList.add('is-active');
      }else if (currentNav === 2) {
        document.querySelector('.js-q3').classList.add('is-active');
      }else {
        return;
      }
    }

    //attach events to custom buttons
    document.querySelector('.js-prev').addEventListener('click', e => {
      splide.go('-1');
      if(currentNav === 0) {
        currentNav = 2;
      }else{
        currentNav = currentNav - 1;
      }
      changeNav();
    });

     document.querySelector('.js-next').addEventListener('click', e => {
      splide.go('+1');
       if(currentNav === 2) {
        currentNav = 0;
      }else {
        currentNav = currentNav + 1;
      }
      changeNav();
    });

    document.querySelector('.js-q1').addEventListener('click', e => {
      navReset();
      document.querySelector('.js-q1').classList.add('is-active');
      splide.go(0);
      currentNav = 0;
    })

    document.querySelector('.js-q2').addEventListener('click', e => {
      navReset();
      document.querySelector('.js-q2').classList.add('is-active');
      splide.go(1);
      currentNav = 1;
    })

    document.querySelector('.js-q3').addEventListener('click', e => {
      navReset();
      document.querySelector('.js-q3').classList.add('is-active');
      splide.go(2);
      currentNav = 2;
    })

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-song-rizin"]) return;
  try {
    
  $(function () {
    $('.js-more-ashley').on('click', () => {
      $('.song-artist-desc-more-ashley').addClass('is-open');
      $('.js-more-ashley').addClass('is-hidden');
    });
    $('.js-more-hori').on('click', () => {
      $('.song-artist-desc-more-hori').addClass('is-open');
      $('.js-more-hori').addClass('is-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-song"]) return;
  try {
    
$(function() {
  $('.js-more-ashley').on('click', () => {
    $('.song-artist-desc-more-ashley').addClass('is-open');
    $('.js-more-ashley').addClass('is-hidden');
  });
  $('.js-more-hori').on('click', () => {
    $('.song-artist-desc-more-hori').addClass('is-open');
    $('.js-more-hori').addClass('is-hidden');
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gummy-mv"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contentElement = document.querySelector('.gummy-mv');
    const floatingElement = document.querySelector('.gummy-floating-element');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          floatingElement.classList.add('gummy-show');
        } else {
          floatingElement.classList.remove('gummy-show');
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(contentElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-app"]) return;
  try {
    
   document.addEventListener('DOMContentLoaded', () => {
    let selectedPoint = 0;

    const firstFeature = document.querySelector(".first-feature");
    const secondFeature = document.querySelector(".second-feature");
    const thirdFeature = document.querySelector(".third-feature");

    const firstPoint = document.querySelector(".first-point");
    const secondPoint = document.querySelector(".second-point");
    const thirdPoint = document.querySelector(".third-point");

    const resetPoint = () => {
      firstFeature.classList.remove("selected");
      secondFeature.classList.remove("selected");
      thirdFeature.classList.remove("selected");

      firstPoint.classList.remove("selected");
      secondPoint.classList.remove("selected");
      thirdPoint.classList.remove("selected");

      if(selectedPoint === 0) {
        firstPoint.classList.add("selected");
        firstFeature.classList.add("selected");
      }else if(selectedPoint === 1) {
        secondPoint.classList.add("selected");
        secondFeature.classList.add("selected");
      }else if(selectedPoint === 2) {
        thirdPoint.classList.add("selected");
        thirdFeature.classList.add("selected");
      }
    }

    document.querySelector(".feature-selector-arrow-left").addEventListener("touchstart", () => {
      if(selectedPoint === 0) {
        selectedPoint = 2;
      }else {
        selectedPoint = selectedPoint - 1;
      }
       resetPoint();
     });

    document.querySelector(".feature-selector-arrow-right").addEventListener("touchstart", () => {
      if(selectedPoint === 2) {
        selectedPoint = 0;
      }else {
        selectedPoint = selectedPoint + 1;
      }
       resetPoint();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-anytime"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 60,
      width: '100vw',
      mediaQuery: 'min',
      breakpoints: {
        680: {
          destroy: true,
        },
      },
    };
    new Splide('.exercise-splide', options).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-feature"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const options = {
    pagination: false,
    gap: 16
  };
  new Splide( '.feature-splide', options ).mount();
  new Splide( '.amino-splide', options ).mount();

  MicroModal.init({
    disableScroll: true,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 16,
      mediaQuery: "min",
      breakpoints: {
        680: {
          destroy: true,
        },
      },
    };
    new Splide( '.plus-splide1', options ).mount();
    new Splide( '.plus-splide2', options ).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-commitment"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 16,
      gap: '40px',
      breakpoints: {
        680: {
          gap: '40px',
        },
      },
    };
    new Splide('.commitment-splide', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-feature"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 16,
      gap: '40px',
      breakpoints: {
        680: {
          gap: '40px',
        },
      },
    };
    new Splide('.feature-splide', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-message"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      arrows: false,
      type: 'loop',
      focus: 'center',
      gap: '68px',
      breakpoints: {
        680: {
          gap: '24px',
        },
      },
    };
    const splide = new Splide('.questionnaire-splide', options).mount();

    const navReset = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
    };

    let currentNav = 0;

    const changeNav = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
      if (currentNav === 0) {
        document.querySelector('.js-q1').classList.add('is-active');
      } else if (currentNav === 1) {
        document.querySelector('.js-q2').classList.add('is-active');
      } else if (currentNav === 2) {
        document.querySelector('.js-q3').classList.add('is-active');
      } else {
        return;
      }
    };

    //attach events to custom buttons
    document.querySelector('.js-prev').addEventListener('click', (e) => {
      splide.go('-1');
      if (currentNav === 0) {
        currentNav = 2;
      } else {
        currentNav = currentNav - 1;
      }
      changeNav();
    });

    document.querySelector('.js-next').addEventListener('click', (e) => {
      splide.go('+1');
      if (currentNav === 2) {
        currentNav = 0;
      } else {
        currentNav = currentNav + 1;
      }
      changeNav();
    });

    document.querySelector('.js-q1').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q1').classList.add('is-active');
      splide.go(0);
      currentNav = 0;
    });

    document.querySelector('.js-q2').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q2').classList.add('is-active');
      splide.go(1);
      currentNav = 1;
    });

    document.querySelector('.js-q3').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q3').classList.add('is-active');
      splide.go(2);
      currentNav = 2;
    });

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-mv"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contentElement = document.querySelector('.snack-mv');
    const floatingElement = document.querySelector('.snack-floating-element');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          floatingElement.classList.add('snack-show');
        } else {
          floatingElement.classList.remove('snack-show');
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(contentElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-ark-hills"]) return;
  try {
    
  $(function () {
  // メイン画像のオプション
    $(".store-image-slider").slick({
      autoplay: false, // 自動再生ON
      arrows: false, // 矢印非表示
      fade: true,
      asNavFor: ".store-image-thumbnail", // サムネイルと同期
    });
    // サムネイルのオプション
    $(".store-image-thumbnail").slick({
      autoplay: false,
      slidesToShow: 3, // サムネイルの表示数
      asNavFor: ".store-image-slider", // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-azabujuban"]) return;
  try {
    
  $(function () {
  // メイン画像のオプション
    $(".store-image-slider").slick({
      autoplay: false, // 自動再生ON
      arrows: false, // 矢印非表示
      fade: true,
      asNavFor: ".store-image-thumbnail", // サムネイルと同期
    });
    // サムネイルのオプション
    $(".store-image-thumbnail").slick({
      autoplay: false,
      slidesToShow: 3, // サムネイルの表示数
      asNavFor: ".store-image-slider", // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-ginza-loft"]) return;
  try {
    
  $(function () {
    // メイン画像のオプション
    $('.store-image-slider').slick({
      autoplay: false, // 自動再生ON
      arrows: false, // 矢印非表示
      fade: true,
      asNavFor: '.store-image-thumbnail', // サムネイルと同期
    });
    // サムネイルのオプション
    $('.store-image-thumbnail').slick({
      autoplay: false,
      slidesToShow: 3, // サムネイルの表示数
      asNavFor: '.store-image-slider', // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-shibuya-loft"]) return;
  try {
    
  $(function () {
    // メイン画像のオプション
    $('.store-image-slider').slick({
      autoplay: false, // 自動再生ON
      arrows: false, // 矢印非表示
      fade: true,
      asNavFor: '.store-image-thumbnail', // サムネイルと同期
    });
    // サムネイルのオプション
    $('.store-image-thumbnail').slick({
      autoplay: false,
      slidesToShow: 3, // サムネイルの表示数
      asNavFor: '.store-image-slider', // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-yaechika"]) return;
  try {
    
  $(function () {
  // メイン画像のオプション
    $(".store-image-slider").slick({
      autoplay: false, // 自動再生ON
      arrows: false, // 矢印非表示
      fade: true,
      asNavFor: ".store-image-thumbnail", // サムネイルと同期
    });
    // サムネイルのオプション
    $(".store-image-thumbnail").slick({
      autoplay: false,
      slidesToShow: 3, // サムネイルの表示数
      asNavFor: ".store-image-slider", // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-list-features"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let selectedPoint = 0;

    const firstFeature = document.querySelector('.first-feature');
    const secondFeature = document.querySelector('.second-feature');
    const thirdFeature = document.querySelector('.third-feature');

    const firstPoint = document.querySelector('.first-point');
    const secondPoint = document.querySelector('.second-point');
    const thirdPoint = document.querySelector('.third-point');

    const resetPoint = () => {
      firstFeature.classList.remove('selected');
      secondFeature.classList.remove('selected');
      thirdFeature.classList.remove('selected');

      firstPoint.classList.remove('selected');
      secondPoint.classList.remove('selected');
      thirdPoint.classList.remove('selected');

      if (selectedPoint === 0) {
        firstPoint.classList.add('selected');
        firstFeature.classList.add('selected');
      } else if (selectedPoint === 1) {
        secondPoint.classList.add('selected');
        secondFeature.classList.add('selected');
      } else if (selectedPoint === 2) {
        thirdPoint.classList.add('selected');
        thirdFeature.classList.add('selected');
      }
    };

    document.querySelector('.feature-selector-arrow-left').addEventListener('touchstart', () => {
      if (selectedPoint === 0) {
        selectedPoint = 2;
      } else {
        selectedPoint = selectedPoint - 1;
      }
      resetPoint();
    });

    document.querySelector('.feature-selector-arrow-right').addEventListener('touchstart', () => {
      if (selectedPoint === 2) {
        selectedPoint = 0;
      } else {
        selectedPoint = selectedPoint + 1;
      }
      resetPoint();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-pickup"]) return;
  try {
    
  $(function() {
    let pickupListNumber = 0;
    
    $(".js-prev-button").on("click", function() {
      if(pickupListNumber === 0) {
        pickupListNumber = 3;
      }else {
        pickupListNumber = pickupListNumber - 1;
      }
      const listWrapperWidth = $(".js-list-wrapper").outerWidth();
      $(".js-pickup-list").css("transform", "translateX(" + (-pickupListNumber * listWrapperWidth) + "px)");
    });

    $(".js-next-button").on("click", function() {
      if(pickupListNumber === 3) {
        pickupListNumber = 0;
      }else {
        pickupListNumber = pickupListNumber + 1;
      }
      const listWrapperWidth = $(".js-list-wrapper").outerWidth();
       $(".js-pickup-list").css("transform", "translateX(" + (-pickupListNumber * listWrapperWidth) + "px)");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-project2"]) return;
  try {
    
$(function(){
  // ajaxでWPからproject2の記事を取得
  $.ajax({
      type: 'GET',
      url: 'http://project2.tokyo/wp-json/wp/v2/posts?per_page=10&_embed&categories=64',
      dataType: 'json'
  }).done(function(json){
    let html = '';
    //記事の件数分イテレートする
    $.each(json, function( i, row ) {
      //記事のタイトル
      const title = row.title.rendered;
      //記事のURL
      const link = row.link;
      // 記事のカテゴリ
      const category = row['_embedded']['wp:term'][0][0]['name'];
      //サムネイル画像のURL
      let thumbnail;
      if( row['_embedded']['wp:featuredmedia']　&& row['_embedded']['wp:featuredmedia'][0]['code'] !== "rest_forbidden" ) {
         thumbnail = row['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['full']['source_url']
      }

      // html整形
      html += `<a class="project2-article" href="${link}" target="_blank">`;
      html += `<img class="project2-bg-image" src="${thumbnail || "https://res.cloudinary.com/cdn-2foods/image/upload/v1649379556/official/home/our_impact_our_impact_01.webp"}")/>`;
      // html += '<h3><a href="' + link + '">' + title + '</a></h3>';
      html += `<div class="project2-article-text-wrapper">`;
      html += `<h4 class="project2-article-category">${category}</h4>`;
      html += `<h3 class="project2-article-title">${title}</h3>`;
      html += "</div>"
      html += '</a>';
    });
    
    // 整形したhtmlをページに追加する
    $('.js-project2-posts').append(html)
    
    // スライドショー設定
    $(".js-project2-posts").slick({
      fade: true,    // fadeオン
      speed: 1500,   // 画像切り替えにかかる時間（ミリ秒）
      autoplaySpeed: 3000,   // 自動スライド切り替え速度
      arrows: false,         // 矢印表示・非表示
      autoplay: true,        // 自動再生
      slidesToShow: 1,       // スライド表示数
      slidesToScroll: 1,     // スライドする数
      infinite: true         // 無限リピート オン・オフ
    });
  }).fail(function(json){
      console.error('Project2のブログ記事取得に失敗しました。')
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slideshow-bk"]) return;
  try {
    
  $(function() {
    $(".js-top-slide").slick({
      fade: true,    // fadeオン
      speed: 1500,   // 画像切り替えにかかる時間（ミリ秒）
      autoplaySpeed: 6000,   // 自動スライド切り替え速度
      arrows: false,         // 矢印表示・非表示
      autoplay: true,        // 自動再生
      slidesToShow: 1,       // スライド表示数
      slidesToScroll: 1,     // スライドする数
      infinite: true        // 無限リピート オン・オフ
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slideshow"]) return;
  try {
    
  $(function () {
    $('.js-top-slide').slick({
      fade: true, // fadeオン
      speed: 1500, // 画像切り替えにかかる時間（ミリ秒）
      autoplaySpeed: 6000, // 自動スライド切り替え速度
      arrows: false, // 矢印表示・非表示
      autoplay: true, // 自動再生
      slidesToShow: 1, // スライド表示数
      slidesToScroll: 1, // スライドする数
      infinite: true, // 無限リピート オン・オフ
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-ceramide-mv"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contentElement = document.querySelector('.water-ceramide-mv');
    const floatingElement = document.querySelector('.water-ceramide-floating-element');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          floatingElement.classList.add('water-ceramide-show');
        } else {
          floatingElement.classList.remove('water-ceramide-show');
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(contentElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-ceramide-vc"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      arrows: false,
      type: 'loop',
      focus: 'center',
      gap: '68px',
      breakpoints: {
        680: {
          gap: '24px',
        },
      },
    };
    const splide = new Splide('.questionnaire-splide', options).mount();

    const navReset = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
    };

    let currentNav = 0;

    const changeNav = () => {
      document.querySelector('.js-q1').classList.remove('is-active');
      document.querySelector('.js-q2').classList.remove('is-active');
      document.querySelector('.js-q3').classList.remove('is-active');
      if (currentNav === 0) {
        document.querySelector('.js-q1').classList.add('is-active');
      } else if (currentNav === 1) {
        document.querySelector('.js-q2').classList.add('is-active');
      } else if (currentNav === 2) {
        document.querySelector('.js-q3').classList.add('is-active');
      } else {
        return;
      }
    };

    //attach events to custom buttons
    document.querySelector('.js-prev').addEventListener('click', (e) => {
      splide.go('-1');
      if (currentNav === 0) {
        currentNav = 2;
      } else {
        currentNav = currentNav - 1;
      }
      changeNav();
    });

    document.querySelector('.js-next').addEventListener('click', (e) => {
      splide.go('+1');
      if (currentNav === 2) {
        currentNav = 0;
      } else {
        currentNav = currentNav + 1;
      }
      changeNav();
    });

    document.querySelector('.js-q1').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q1').classList.add('is-active');
      splide.go(0);
      currentNav = 0;
    });

    document.querySelector('.js-q2').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q2').classList.add('is-active');
      splide.go(1);
      currentNav = 1;
    });

    document.querySelector('.js-q3').addEventListener('click', (e) => {
      navReset();
      document.querySelector('.js-q3').classList.add('is-active');
      splide.go(2);
      currentNav = 2;
    });

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-ceramide-vitamin-c"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      pagination: false,
      gap: 16,
      gap: '40px',
      breakpoints: {
        680: {
          gap: '40px',
        },
      },
    };
    new Splide('.vitamin-splide', options).mount();

    MicroModal.init({
      disableScroll: true,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
